import { Component, OnInit } from '@angular/core';
import { Title, Meta  } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import * as fromStore from '@app/core/store';
import { LoadingIndicatorService } from '@app/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isLoading: boolean;

  constructor(private titleService: Title, private meta: Meta,
    private loadingIndicatorService: LoadingIndicatorService,
    private store: Store<fromStore.State>) { }


  ngOnInit() {
    this.meta.addTag({ name: 'theme-color', content: '#33ddff' });

    /* If we have a valid auth token we will refresh the user only */
    this.store.select(fromStore.selectLoggedIn)
      .take(1)
      .subscribe(isLoggedIn => {   
        if (isLoggedIn) {
          this.store.dispatch(new fromStore.LoadUser());
        }
      });

    this.loadingIndicatorService.indicator$.subscribe(isLoading => this.isLoading = isLoading);

    this.store.select(fromStore.selectRoutingPageTitle)
      .subscribe(title => {
        this.store.dispatch(new fromStore.AppActions.UpdatePageTitle(title));
      });

    this.store.select(fromStore.selectPageTitle)
      .subscribe(title => {
        this.titleService.setTitle('QSTP eServices Portal' + (title ? ' - ' + title : ''))
      });



  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts